define.alias("shared/components/shared/schedule-navbar/notification", "calendar/components/shared/schedule-navbar/notification");